<template>
    <div class="header-container ">
            <el-row>
                <el-col :sm="24" :md="16">
                    <span class="title">Crear ticket</span>
                </el-col>
            </el-row>
        </div>
        <div class="main-content" v-if="loading_fullscreen == false">
            <el-row :gutter="24">
                <el-col :sm="24" :md="16">
                    <!-- Card principal del formulario -->
                    <el-card shadow="hover" class="ticket-form-card">
                        <template #header>
                            <div class="card-header">
                                <span class="title-card">Detalles del Ticket</span>
                            </div>
                        </template>

                        <el-form ref="formRef_ticket" :model="form" :rules="rules" label-position="top" status-icon>
                            <!-- Título del ticket -->
                            <el-row class="mb-4" :gutter="24">
                                <el-col :xs="24" :sm="24" :md="24">
                                    <el-form-item label="Título del ticket" prop="title">
                                        <el-input
                                            v-model="form.title"
                                            placeholder="Ingrese el título del ticket"
                                            maxlength="150"
                                            show-word-limit
                                        />
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <!-- Categoría y Prioridad -->
                            <el-row class="mb-4" :gutter="24">
                                <el-col :xs="24" :sm="24" :md="24">
                                    <el-form-item label="Categoría" prop="category_id">
                                        <el-select
                                            v-model="form.category_id"
                                            placeholder="Seleccione una categoría"
                                            style="width: 100%"
                                        >
                                            <el-option
                                                v-for="category in catalog_categories"
                                                :key="category.id"
                                                :label="category.name"
                                                :value="category.id"
                                            />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <el-row class="mb-4" :gutter="24">
                                <el-col :xs="24" :sm="24" :md="24">
                                    <el-form-item label="Descripción del problema" prop="description">
                                        <el-input
                                            v-model="form.description"
                                            type="textarea"
                                            :rows="6"
                                            placeholder="Describa detalladamente el problema o solicitud..."
                                            maxlength="2000"
                                            show-word-limit
                                        />
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <!-- Archivos adjuntos -->
                            <el-row class="mb-4" :gutter="24">
                                <el-col :xs="24" :sm="24" :md="24">
                                    <el-form-item label="Archivos adjuntos" prop="attachments">
                                        <div 
                                            class="upload-section"
                                            @paste="handlePaste"
                                            @dragover.prevent
                                            @drop.prevent="handleDrop"
                                            tabindex="0"
                                            ref="uploadSection"
                                        >
                                            <!-- Área de upload tradicional -->
                                            <div class="upload-area">
                                                <el-upload
                                                    ref="uploadRef"
                                                    action="#"
                                                    :auto-upload="false"
                                                    :file-list="fileList"
                                                    :on-change="handleFileChange"
                                                    :on-remove="handleFileRemove"
                                                    :before-upload="beforeUpload"
                                                    accept=".jpg,.png,.pdf,.txt"
                                                    :limit="5"
                                                    multiple
                                                    drag
                                                >
                                                    <div class="upload-content">
                                                        <font-awesome-icon :icon="['fas', 'cloud-upload-alt']" class="upload-icon" />
                                                        <div class="upload-text">
                                                            <p>Arrastra archivos aquí, <em>haz clic para subir</em> o presiona <strong>Ctrl+V para pegar del portapapeles</strong></p>
                                                            <small class="text-muted">
                                                                Máximo {{ maxFiles }} archivos de {{ maxFileSize / 1024 / 1024 }}MB cada uno en formato JPG, PNG PDF o TXT
                                                                <br>• Soporta pegado desde portapapeles
                                                            </small>
                                                        </div>
                                                    </div>
                                                </el-upload>
                                            </div>

                                            <!-- Vista previa de archivos -->
                                            <div v-if="fileList.length > 0" class="files-preview">
                                                <h4>Archivos seleccionados ({{ fileList.length }}/{{ maxFiles }}):</h4>
                                                <div class="files-grid">
                                                    <div 
                                                        v-for="(file, index) in fileList" 
                                                        :key="'file-' + file.uid" 
                                                        class="file-item"
                                                    >
                                                        <!-- Vista previa de imagen -->
                                                        <div v-if="isImageFile(file)" class="image-preview">
                                                            <img :src="getFilePreview(file)" :alt="file.name" />
                                                            <div class="file-overlay">
                                                                <div class="file-name-overlay">{{ file.name }}</div>
                                                                <div class="file-actions">
                                                                    <span class="file-size">{{ formatFileSize(file.size) }}</span>
                                                                    <el-button 
                                                                        type="danger" 
                                                                        size="small" 
                                                                        circle 
                                                                        @click="removeFile(index)"
                                                                        class="remove-btn"
                                                                    >
                                                                        <font-awesome-icon :icon="['fas', 'times']" />
                                                                    </el-button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        
                                                        <!-- Vista de archivo no imagen -->
                                                        <div v-else class="file-preview">
                                                            <div class="file-icon">
                                                                <font-awesome-icon :icon="getFileIcon(file)" />
                                                            </div>
                                                            <div class="file-info">
                                                                <span class="file-name" :title="file.name">{{ file.name }}</span>
                                                                <span class="file-size">{{ formatFileSize(file.size) }}</span>
                                                            </div>
                                                            <el-button 
                                                                type="danger" 
                                                                size="small" 
                                                                circle 
                                                                @click="removeFile(index)"
                                                                class="remove-btn"
                                                            >
                                                                <font-awesome-icon :icon="['fas', 'times']" />
                                                            </el-button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>

                            <!-- Botones de acción -->
                            <el-row class="mb-2">
                                <el-col :xs="24" :sm="24" :md="24" class="text-right">
                                    <el-button @click="closeModalParent">
                                        Cancelar
                                    </el-button>
                                    <el-button @click="resetForm">
                                        Limpiar
                                    </el-button>
                                    <el-button class="btn-primary" @click="saveTicket()" :loading="loading_save">
                                        Crear ticket
                                    </el-button>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-card>
                </el-col>

                <el-col :sm="24" :md="8">
                    <el-card shadow="hover" class="info-card">
                        <!-- Información del usuario actual -->
                        <div class="user-info">
                            <h3>Reportado por:</h3>
                            <div class="user-details">
                                <p> <font-awesome-icon :icon="['fas', 'user']" class="text-primary" /> <strong class="has-text-dark">{{ currentUser.name }}</strong></p>
                                <p> <font-awesome-icon :icon="['fas', 'envelope']" class="text-primary" /> <strong class="has-text-dark">{{ currentUser.email }}</strong></p>
                            </div>
                        </div>

                        <el-divider />

                        <!-- Guía rápida -->
                        <div class="quick-guide">
                            <h3>Guía rápida:</h3>
                            <ul class="guide-list">
                                <li><strong class="has-text-dark">Título:</strong> Sea específico y claro</li>
                                <li><strong class="has-text-dark">Categoría:</strong> Seleccione la más apropiada</li>
                                <li><strong class="has-text-dark">Estatus (informativo):</strong>
                                    <ul>
                                        <li v-for="status in catalog_status" :key="status.id"><el-tag   :style="{ background: status.color }" effect="dark" size="small">{{ status.name }}</el-tag></li>
                                    </ul>
                                </li>
                                <li><strong class="has-text-dark">Descripción:</strong> Incluya detalles, pasos para reproducir, y cualquier información relevante</li>
                                <li><strong class="has-text-dark">Archivos:</strong> 
                                    <ul>
                                        <!-- <li>📎 Arrastre o haga clic para subir</li> -->
                                        <li>📋 <kbd>Ctrl+V</kbd> para pegar capturas</li>
                                        <li>📁 Máximo {{ maxFiles }} archivos de {{ maxFileSize / 1024 / 1024 }}MB</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>

        <div class="main-content" v-else>
            <el-row>
                <el-col :sm="24" :md="24"  v-loading="true">
                    <br>
                    <br>
                    <br>
                    <br>
                    <br>
                    <br>
                </el-col>
            </el-row>
        </div>

</template>
<script>

import apiClient from '@/api/apiClient';
import { useUserStore } from '@/stores/user';
import { ElNotification } from 'element-plus';

export default {
    name: "component-create-ticket",
    props: {
        closeModalParent: {
            type: Function,
            required: true
        }
    },
    components: {
        
    },
    data() {
        return {
            loading_fullscreen: false,
            loading_save: false,
            form: {
                title: '',
                description: '',
                category_id: null,
                attachments: []
            },
            rules: {
                title: [
                    { required: true, message: 'El título del ticket es requerido', trigger: 'blur' },
                    { min: 1, max: 150, message: 'El título debe tener entre 5 y 150 caracteres', trigger: 'blur' }
                ],
                description: [
                    { required: true, message: 'La descripción es requerida', trigger: 'blur' },
                    { min: 1, max: 2000, message: 'La descripción debe tener entre 20 y 2000 caracteres', trigger: 'blur' }
                ],
                category_id: [
                    { required: true, message: 'Debe seleccionar una categoría', trigger: 'change' }
                ],
                attachments: [
                    { 
                        validator: (rule, value, callback) => {
                            if (this.fileList.length > this.maxFiles) {
                                callback(new Error(`Máximo ${this.maxFiles} archivos permitidos`));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'change'
                    }
                ]
            },
            catalog_categories: [],
            catalog_status:[],
            fileList: [],
            maxFiles: 5,
            maxFileSize: 10 * 1024 * 1024, // 10MB
            allowedTypes: [
                'image/jpeg', 'image/png',
                'application/pdf', 'text/plain'
            ]
        }
    },
    mounted() {
        this.initializeForm();
        // Agregar event listener global para Ctrl+V
        document.addEventListener('paste', this.handleGlobalPaste);
        
        // Enfocar la sección de upload para que pueda recibir eventos
        this.$nextTick(() => {
            if (this.$refs.uploadSection) {
                this.$refs.uploadSection.focus();
            }
        });

        this.getCatalogCategories();
        this.getCatalogStatus();

    },
    beforeUnmount() {
        // Limpiar event listener
        document.removeEventListener('paste', this.handleGlobalPaste);
    },
    created() {
        
    },
    methods: {
        initializeForm() {
            this.resetForm();
            // Obtener información del usuario actual
            const userStore = useUserStore();
            if (userStore.getUserInfo()) {
                this.form.user_id = userStore.getUserInfo().id;
            }
        },

        async getCatalogCategories(){

            this.loading_fullscreen=true;

            await apiClient.get('/ticket/catalog-categories')
            .then(response =>{
                this.catalog_categories = response.data.data
                this.loading_fullscreen=false;
            })
            .catch(error =>{
                console.error('¡There was an error!', error);
                ElNotification({
                                    title: 'Error',
                                    message: "Ha ocurrido un error, intente de nuevo.",
                                    type: 'error',
                                })
                this.loading_fullscreen=false;
            });
        },

        async getCatalogStatus() {
            this.loading_fullscreen=true;

            await apiClient.get('/ticket/catalog-status')
            .then(response =>{
                this.catalog_status = response.data.data
                this.loading_fullscreen=false;
            })
            .catch(error =>{
                console.error('¡There was an error!', error);
                ElNotification({
                                    title: 'Error',
                                    message: "Ha ocurrido un error, intente de nuevo.",
                                    type: 'error',
                                })
                this.loading_fullscreen=false;
            });
        },

        async saveTicket() {
            this.$refs.formRef_ticket.validate(async (valid) => {
                if (valid) {
                    this.loading_save = true;

                    try {
                        // Preparar FormData para enviar archivos
                        const formData = new FormData();
                        
                        // Agregar campos del formulario
                        Object.keys(this.form).forEach(key => {
                            if (key !== 'attachments' && this.form[key] !== null) {
                                formData.append(key, this.form[key]);
                            }
                        });

                        // Agregar archivos
                        this.fileList.forEach((file, index) => {
                            if (file.raw) {
                                formData.append(`attachments[${index}]`, file.raw);
                            }
                        });

                        // Realizar petición al servidor
                        const response = await apiClient.post('/ticket/create', formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                            },
                        });

                        ElNotification({
                            title: 'Éxito',
                            message: response.data.msg || 'Ticket creado exitosamente',
                            type: 'success',
                            duration: 3000,
                        });
                        
                        // Cerrar el modal de crear ticket
                        this.closeModalParent();
                        
                        // Limpiar formulario
                        this.resetForm();
                        
                        // Emitir evento o navegar según sea necesario
                        this.$emit('ticketCreated', response.data.data);

                    } catch (error) {
                        console.error('Error creating ticket:', error);
                        
                        ElNotification({
                            title: 'Error',
                            message: error.response?.data?.msg || 'Ha ocurrido un error al crear el ticket',
                            type: 'error',
                            duration: 3000,
                        });
                    } finally {
                        this.loading_save = false;
                    }
                } else {
                    ElNotification({
                        title: 'Error',
                        message: 'Por favor, complete los campos requeridos correctamente.',
                        type: 'error',
                        duration: 3000,
                    });
                }
            });
        },

        async validateForm() {
            return this.$refs.formRef_ticket.validate();
        },

        resetForm() {
            // Liberar URLs de preview para evitar memory leaks
            this.fileList.forEach(file => {
                if (file.preview) {
                    URL.revokeObjectURL(file.preview);
                }
            });

            this.$refs.formRef_ticket.resetFields();
            this.fileList = [];
            
            // Limpiar el componente de upload
            if (this.$refs.uploadRef) {
                this.$refs.uploadRef.clearFiles();
            }
        },

        handleFileChange(file, fileList) {
            console.log(file.raw);
            const isValidType     = this.allowedTypes.includes(file.raw.type);
            const isValidFileSize = file.raw.size <= this.maxFileSize ? true : false;

            if (!isValidType) {
                ElNotification({
                    title: 'Archivo no válido',
                    message: 'Tipo de archivo no permitido. Use imágenes, PDF o archivos de texto.',
                    type: 'warning',
                    duration: 8000
                });

                this.$refs.uploadRef.handleRemove(file);
                return;
            }

            if (!isValidFileSize) {
                ElNotification({
                    title: 'Archivo muy grande',
                    message: `El archivo es muy grande. Máximo ${this.maxFileSize / 1024 / 1024}MB permitidos.`,
                    type: 'warning',
                    duration: 8000
                });

                this.$refs.uploadRef.handleRemove(file);
                return;
            }

            this.fileList = fileList;
            // Trigger validation for attachments
            this.$nextTick(() => {
                this.$refs.formRef_ticket.validateField('attachments');
            });
        },

        handleFileRemove(file, fileList) {
            this.fileList = fileList;
            // Trigger validation for attachments
            this.$nextTick(() => {
                this.$refs.formRef_ticket.validateField('attachments');
            });
        },

        beforeUpload(file) {
            // Validar tipo de archivo
            if (!this.allowedTypes.includes(file.type)) {
                ElNotification({
                    title: 'Archivo no válido',
                    message: 'Tipo de archivo no permitido. Use imágenes, PDF o archivos de texto.',
                    type: 'warning',
                    duration: 8000
                });
                return false;
            }

            // Validar tamaño de archivo
            if (file.size > this.maxFileSize) {
                ElNotification({
                    title: 'Archivo muy grande',
                    message: `El archivo ${file.name} es muy grande. Máximo ${this.maxFileSize / 1024 / 1024}MB permitidos.`,
                    type: 'warning',
                });
                return false;
            }

            // Validar cantidad de archivos
            if (this.fileList.length >= this.maxFiles) {
                ElNotification({
                    title: 'Límite alcanzado',
                    message: `Máximo ${this.maxFiles} archivos permitidos.`,
                    type: 'warning',
                });
                return false;
            }

            return true;
        },

        // Manejar el pegado de imágenes desde el portapapeles
        async handlePaste(event) {
            const items = event.clipboardData?.items;
            if (!items) return;

            for (let i = 0; i < items.length; i++) {
                const item = items[i];
                
                // Solo procesar archivos de imagen
                if (item.type.indexOf('image/') === 0) {
                    event.preventDefault();
                    
                    const file = item.getAsFile();
                    if (file) {
                        await this.processPastedImage(file);
                    }
                }
            }
        },

        // Manejar pegado global en el formulario
        async handleGlobalPaste(event) {
            // Solo procesar si el evento ocurre dentro del componente
            const isInsideComponent = this.$el && this.$el.contains(event.target);
            if (!isInsideComponent) return;

            // No procesar si el usuario está escribiendo en un input o textarea
            const tagName = event.target.tagName.toLowerCase();
            const isInputElement = tagName === 'input' || tagName === 'textarea';
            const isContentEditable = event.target.contentEditable === 'true';
            
            if (isInputElement || isContentEditable) return;

            // Verificar si hay imágenes en el portapapeles
            const items = event.clipboardData?.items;
            if (!items) return;

            let hasImages = false;
            for (let i = 0; i < items.length; i++) {
                if (items[i].type.indexOf('image/') === 0) {
                    hasImages = true;
                    break;
                }
            }

            // Si hay imágenes, procesarlas
            if (hasImages) {
                event.preventDefault();
                await this.handlePaste(event);
            }
        },

        // Manejar el drop de archivos
        async handleDrop(event) {
            const files = event.dataTransfer.files;
            
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                
                if (file.type.indexOf('image/') === 0) {
                    await this.processPastedImage(file);
                } else {
                    // Para archivos no imagen, usar el upload normal
                    this.addFileToUpload(file);
                }
            }
        },

        // Procesar imagen pegada
        async processPastedImage(file) {
            // Validar límite de archivos
            if (this.fileList.length >= this.maxFiles) {
                ElNotification({
                    title: 'Límite alcanzado',
                    message: `Máximo ${this.maxFiles} archivos permitidos.`,
                    type: 'warning',
                });
                return;
            }

            // Validar tamaño
            if (file.size > this.maxFileSize) {
                ElNotification({
                    title: 'Archivo muy grande',
                    message: `La imagen es muy grande. Máximo ${this.maxFileSize / 1024 / 1024}MB permitidos.`,
                    type: 'warning',
                });
                return;
            }

            // Crear un nombre único para la imagen pegada
            const timestamp = new Date().getTime();
            const extension = file.type.split('/')[1] || 'png';
            const fileName = `captura_pantalla_${timestamp}.${extension}`;

            // Crear un nuevo archivo con el nombre personalizado
            const renamedFile = new File([file], fileName, { type: file.type });

            // Agregar al upload component
            this.addFileToUpload(renamedFile);

            ElNotification({
                title: '📋 Imagen agregada',
                message: `Se agregó la captura de pantalla como "${fileName}".`,
                type: 'success',
                duration: 3000,
            });
        },

        // Agregar archivo al componente de upload
        addFileToUpload(file) {
            const uploadFile = {
                name: file.name,
                size: file.size,
                type: file.type,
                raw: file,
                uid: Date.now() + Math.random(),
                status: 'ready'
            };

            this.fileList.push(uploadFile);
            
            // Trigger validation
            this.$nextTick(() => {
                this.$refs.formRef_ticket.validateField('attachments');
            });
        },

        // Métodos de utilidad para los archivos
        removeFile(index) {
            const file = this.fileList[index];
            
            // Liberar URL de preview si existe
            if (file && file.preview) {
                URL.revokeObjectURL(file.preview);
            }

            this.fileList.splice(index, 1);
            this.$nextTick(() => {
                this.$refs.formRef_ticket.validateField('attachments');
            });
        },

        isImageFile(file) {
            return file.type && file.type.startsWith('image/');
        },

        getFilePreview(file) {
            if (file.raw && this.isImageFile(file)) {
                return URL.createObjectURL(file.raw);
            }
            return '';
        },

        getFileIcon(file) {
            if (file.type) {
                if (file.type.startsWith('image/')) return ['fas', 'image'];
                if (file.type === 'application/pdf') return ['fas', 'file-pdf'];
                if (file.type.includes('word')) return ['fas', 'file-word'];
                if (file.type.includes('excel') || file.type.includes('sheet')) return ['fas', 'file-excel'];
                if (file.type.startsWith('text/')) return ['fas', 'file-alt'];
            }
            return ['fas', 'file'];
        },

        formatFileSize(bytes) {
            if (bytes === 0) return '0 Bytes';
            const k = 1024;
            const sizes = ['Bytes', 'KB', 'MB', 'GB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
        }
    },
    computed: {
        currentUser() {
            const userStore = useUserStore();
            return userStore.getUserInfo() || {
                name: 'Usuario Actual',
                email: 'usuario@veterinaria.com',
                role: 'Empleado'
            };
        }
    }
}
</script>

  
<style>
/* === ESTILOS PARA EL FORMULARIO DE CREAR TICKET === */

/* Card principal */
.ticket-form-card {
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-left: 4px solid var(--color-primary, #007bff);
}

.info-card {
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    border-left: 4px solid var(--color-info, #17a2b8);
}

/* Header del card */
.card-header {
    display: flex;
    align-items: center;
    gap: 8px;
}

.title-card {
    font-weight: 600;
    font-size: 16px;
}

/* Formulario */
.form-label {
    font-weight: 600;
    color: var(--color-text-primary, #333);
    margin-bottom: 8px;
    display: block;
}

.text-danger {
    color: #dc3545;
}

.text-error {
    color: #dc3545;
    font-size: 12px;
    margin-top: 4px;
    display: block;
}

.w-100 {
    width: 100%;
}

/* Opciones de prioridad */
.priority-option {
    display: flex;
    align-items: center;
    width: 100%;
}

.priority-option .el-tag {
    margin-right: 8px;
}

/* Opciones de usuario */
.user-option {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.text-muted {
    color: #6c757d;
    font-size: 12px;
}

/* Área de upload */
.upload-section {
    display: flex;
    flex-direction: column;
    gap: 16px;
    outline: none; /* Quitar outline cuando esté enfocado */
}

.upload-section:focus {
    outline: none;
}

.upload-area {
    border: 2px dashed #d1d5db;
    border-radius: 8px;
    padding: 20px;
    transition: all 0.3s ease;
}

.upload-area:hover {
    border-color: var(--color-primary, #007bff);
    background-color: #f8f9fa;
}

.upload-content {
    text-align: center;
}

.upload-icon {
    font-size: 48px;
    color: #6c757d;
    margin-bottom: 16px;
}

.upload-text p {
    margin: 0 0 8px 0;
    color: var(--color-text-primary, #333);
    font-size: 14px;
}

.upload-text small {
    color: #6c757d;
    font-size: 12px;
}

.upload-text em {
    color: var(--color-primary, #007bff);
    font-style: normal;
    text-decoration: underline;
}

.upload-text strong {
    color: #28a745;
    font-weight: 600;
}

/* Vista previa de archivos */
.files-preview {
    margin-top: 16px;
    padding: 16px;
    background: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e9ecef;
}

.files-preview h4 {
    margin: 0 0 16px 0;
    font-size: 14px;
    font-weight: 600;
    color: #495057;
    display: flex;
    align-items: center;
    gap: 8px;
}

.files-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 12px;
}

.file-item {
    background: white;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
}

.file-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Vista previa de imagen */
.image-preview {
    position: relative;
    aspect-ratio: 16/9;
    overflow: hidden;
}

.image-preview img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
}

.image-preview:hover img {
    transform: scale(1.05);
}

.file-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
    padding: 12px;
    color: white;
}

.file-name-overlay {
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.file-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.file-actions .file-size {
    font-size: 11px;
    opacity: 0.9;
}

.remove-btn {
    background: rgba(220, 53, 69, 0.9) !important;
    border: none !important;
    color: white !important;
    width: 24px !important;
    height: 24px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
}

.remove-btn:hover {
    background: #dc3545 !important;
    transform: scale(1.1);
}

/* Vista de archivo no imagen */
.file-preview {
    padding: 16px;
    display: flex;
    align-items: center;
    gap: 12px;
    min-height: 80px;
}

.file-icon {
    font-size: 32px;
    color: #6c757d;
    flex-shrink: 0;
}

.file-info {
    flex: 1;
    min-width: 0;
}

.file-name {
    display: block;
    font-weight: 500;
    font-size: 13px;
    color: #495057;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 4px;
}

.file-size {
    font-size: 11px;
    color: #6c757d;
}

.file-preview .remove-btn {
    background: #dc3545 !important;
    flex-shrink: 0;
}

/* Responsive para archivos */
@media (max-width: 768px) {
    .files-grid {
        grid-template-columns: 1fr;
    }
    
    .upload-area {
        padding: 16px;
    }
    
    .upload-icon {
        font-size: 36px;
        margin-bottom: 12px;
    }
    
    .files-preview {
        padding: 12px;
    }
    
    .file-preview {
        padding: 12px;
        min-height: 60px;
    }
    
    .file-icon {
        font-size: 24px;
    }
}

/* Información del usuario */
.user-info {
    margin-bottom: 20px;
}

.user-info h3 {
    margin: 0 0 12px 0;
    font-size: 18px;
    font-weight: 600;
    color: var(--color-text-primary, #333);
}

.user-details p {
    margin: 4px 0;
    font-size: 14px;
}

/* Guía rápida */
.quick-guide {
    margin-top: 20px;
}

.quick-guide h3 {
    margin: 0 0 12px 0;
    font-size: 16px;
    font-weight: 600;
    color: var(--color-text-primary, #333);
}

.guide-list {
    margin: 0;
    padding-left: 16px;
    font-size: 13px;
    line-height: 1.6;
}

.guide-list li {
    margin-bottom: 8px;
    color: var(--color-text-secondary, #666);
}

.guide-list ul {
    margin: 4px 0;
    padding-left: 16px;
}

.guide-list ul li {
    margin-bottom: 4px;
    display: flex;
    align-items: center;
    gap: 6px;
}

/* Botones */
.text-right {
    text-align: right;
}

/* Responsive Design */
@media (max-width: 768px) {
    .ticket-form-card,
    .info-card {
        margin-bottom: 20px;
        border-radius: 8px;
    }
    
    .title-card {
        font-size: 14px;
    }
    
    .upload-content {
        padding: 10px;
    }
    
    .upload-icon {
        font-size: 32px;
        margin-bottom: 12px;
    }
    
    .upload-text p {
        font-size: 13px;
    }
    
    .upload-text small {
        font-size: 11px;
    }
    
    .user-info,
    .quick-guide {
        margin-bottom: 16px;
    }
    
    .guide-list {
        font-size: 12px;
    }
}

@media (max-width: 480px) {
    .card-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 4px;
    }
    
    .form-label {
        font-size: 14px;
    }
    
    .text-right {
        text-align: center;
    }
    
    .upload-area {
        padding: 15px 10px;
    }
    
    .upload-icon {
        font-size: 28px;
        margin-bottom: 8px;
    }
}

/* Estados de validación */
.el-form-item.is-error .el-input__wrapper,
.el-form-item.is-error .el-textarea__inner,
.el-form-item.is-error .el-select .el-input__wrapper {
    border-color: #dc3545;
    box-shadow: 0 0 0 1px #dc3545;
}

.el-form-item.is-error .el-input__wrapper:focus,
.el-form-item.is-error .el-textarea__inner:focus,
.el-form-item.is-error .el-select .el-input__wrapper:focus {
    border-color: #dc3545;
    box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.2);
}

/* Divider personalizado */
.el-divider {
    margin: 16px 0;
}

/* Tags de prioridad */
.el-tag {
    border: none;
    /* color: white; */
    font-weight: 500;
}

/* Transiciones */
.upload-area,
.ticket-form-card,
.info-card {
    transition: all 0.3s ease;
}

.ticket-form-card:hover,
.info-card:hover {
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
}
</style>  